<div class="qc-content">
  <div class="company-section">
    <span class="company-select">
      Company:
      <nz-select
        style="width: 120px;"
        [(ngModel)]="ticker"
        (ngModelChange)="setTicker($event)"
      >
        <nz-option
          *ngFor="let ticker of allTickers"
          [nzValue]="ticker.id"
          [nzLabel]="ticker.name"
        ></nz-option>
      </nz-select>
    </span>
  </div>
  <div nz-row nzType="flex" nzGutter="10">
    <div nz-col [nzSpan]="12">
      <div class="freshness-container qc-card">
        <app-freshness-chart [ticker]="ticker"></app-freshness-chart>
      </div>
      <div class="consensus-template-container qc-card">
        <app-consensus-template
          [ticker]="ticker"
          (changeNotes)="changeNotes($event)"
        ></app-consensus-template>
      </div>
    </div>
    <div nz-col [nzSpan]="12">
      <div class="forecast-container qc-card">
        <app-forecast-chart [ticker]="ticker"></app-forecast-chart>
      </div>
      <div class="notes-container qc-card">
        <app-notes-section
          [ticker]="ticker"
          [(notesData)]="notesData"
        ></app-notes-section>
      </div>
    </div>
  </div>
</div>
